'use strict';
const angular = require('angular');

/**
 * List of emails of all the members in displayed on admin baskets
 */
export class adminMemberExportEmailsComponent {
  textOfEmails: string;

  $onInit() {
    this.textOfEmails = 'First Name,Last Name,Email\n';
    let resolve = (this as any).resolve;

    // Get the season parameter
    if (_.has(resolve, 'users') && resolve.users !== null) {
      let allUsers = resolve.users;
      allUsers.forEach(user => {
        if (user.membership) {
          this.textOfEmails += user.membership.firstName +','+ user.membership.lastName +','+ user.email +'\n';
        }
      });

    } else {
      this.back();
    }
  }

  back() {
    (this as any).close();
  };
}


export default angular.module('terrappApp.adminMembers')
  .component('adminMemberExportEmails', {
    template: require('./adminMemberExportEmails.html'),
    controller: adminMemberExportEmailsComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;


// WEBPACK FOOTER //
// ./client/app/admin/adminMembers/adminMemberExportEmails.component.ts